import { useState } from "react";
import { ArrowRightLeft, X } from "lucide-react";
import { toast } from "../../lib/notify";
import { http, formatApiError } from "../../lib/api";

// Tüm Kullanıcılar tablosunda seçili kullanıcıları tek seferde başka taşerona taşı
export default function BulkMoveBar({ selected, caris, onDone, onClear }) {
  const [target, setTarget] = useState("");
  const [busy, setBusy] = useState(false);
  if (!selected.length) return null;
  const move = async () => {
    if (!target) return toast.error("Hedef taşeron seçin");
    if (!window.confirm(`${selected.length} kullanıcı seçili taşerona taşınacak. Projeleri hedefe göre yeniden hesaplanır, şube kısıtları sıfırlanır. Devam?`)) return;
    setBusy(true);
    try {
      const { data } = await http.post("/subcontractors/users/bulk-move", { user_ids: selected, target_cari_id: target });
      toast.success(`${data.moved} kullanıcı ${data.cari_name} taşeronuna taşındı`);
      setTarget(""); onDone?.();
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="px-3 py-2 border-b border-orange-200 bg-orange-50 flex items-center gap-3 flex-wrap text-xs" data-testid="sub-users-bulk-bar">
      <span className="font-bold text-orange-800" data-testid="sub-users-bulk-count">{selected.length} kullanıcı seçili</span>
      <label className="inline-flex items-center gap-1.5">Hedef taşeron
        <select value={target} onChange={(e) => setTarget(e.target.value)} data-testid="sub-users-bulk-target" className="px-2 py-1 border border-slate-300 rounded-md bg-white w-64 max-w-full outline-none focus:border-orange-500">
          <option value="">Seçin…</option>{caris.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select></label>
      <button type="button" onClick={move} disabled={busy || !target} data-testid="sub-users-bulk-move" className="inline-flex items-center gap-1 px-3 py-1.5 rounded-md bg-orange-600 text-white font-bold hover:bg-orange-700 disabled:opacity-50"><ArrowRightLeft className="w-3.5 h-3.5" /> {busy ? "Taşınıyor…" : "Taşı"}</button>
      <button type="button" onClick={onClear} data-testid="sub-users-bulk-clear" className="inline-flex items-center gap-1 px-2 py-1.5 text-slate-600 hover:text-slate-900"><X className="w-3.5 h-3.5" /> Seçimi temizle</button>
    </div>
  );
}
